import { render, staticRenderFns } from "./DialogCont.vue?vue&type=template&id=d7836886&scoped=true&"
import script from "./DialogCont.vue?vue&type=script&lang=js&"
export * from "./DialogCont.vue?vue&type=script&lang=js&"
import style0 from "./DialogCont.vue?vue&type=style&index=0&id=d7836886&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7836886",
  null
  
)

export default component.exports